import {useParams,} from "react-router-dom";
import {useSeo} from './hooks/useMetadata';
import Header from "./components/Header";
import GameDetail from "./components/GameDetail";
import Soon from "./pages/Soon";
import React, {useEffect, useState} from "react";
import {fetchGameData} from "./config";

export default function Router() {
    const {slug} = useParams();
    const [game, setGame] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const loadGameData = async () => {
            try {
                setLoading(true);
                setError(null);

                setGame(await fetchGameData({"game_id": slug}));

            } catch (error) {
                console.error('Error loading game data:', error);
                setError('Failed to load game data');
            } finally {
                setLoading(false);
            }
        };

        loadGameData();
    }, [slug]);

    useSeo(
        `استودیو بازیسازی مدریک: ${game.name}`,
        `به استودیوی بازیسازی مدریک خوش آمدید. درباره بازی ${game.name} بیشتر بدانید.`,
        {keywords: `medrick, game studio, mobile game, ${game.name}`}
    );
    return (
        <>
            (<Header title=" بی‌خیالش ! بازی کن"/>
            {game ?
                (<GameDetail game={game}/>)
                : (<Soon/>)}
        </>
    )
        ;
}
